import {
  Chip,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Slide,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDetailsDialog } from "../../../../../app/slices/transferOrderSlice";
import dayjs from "dayjs";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Detail = ({ label, value }) => (
  <Grid item xs={12} md={3}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1">{value ?? "-"}</Typography>
  </Grid>
);

const TransferOrderDetails = () => {
  const dispatch = useDispatch();
  const _Details = useSelector((state) => state.transferOrder.details);
  const order = _Details.data;

  return (
    <Dialog
      open={_Details.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      maxWidth="md"
      onClose={() => dispatch(setDetailsDialog(null))}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {`تفاصيل المناقلة #${order?.id ?? "-"}`}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2} mb={2}>
          <Detail label="من" value={order?.from_user_name} />
          <Detail label="الى" value={order?.to_user_name} />
          <Detail label="انشاءت بواسطة" value={order?.created_by_name} />
          <Detail
            label="تاريخ الانشاء"
            value={
              order?.created_at
                ? dayjs(order.created_at).format("YYYY-MM-DD HH:mm")
                : null
            }
          />
          {order?.note ? (
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                الملاحظات
              </Typography>
              <Typography variant="body1">{order.note}</Typography>
            </Grid>
          ) : null}
        </Grid>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>المنتج</TableCell>
              <TableCell>العدد</TableCell>
              <TableCell>الارقام التسلسلية</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {order?.items?.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.product_name}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{ flexWrap: "wrap", rowGap: 1 }}
                  >
                    {item.serial_numbers?.length ? (
                      item.serial_numbers.map((serial) => (
                        <Chip key={serial} size="small" label={serial} />
                      ))
                    ) : (
                      <Typography variant="body2">-</Typography>
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default TransferOrderDetails;
